import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-h6" }, "Daglig rapport", -1)
const _hoisted_3 = { class: "text-body1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Hämtar data... ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_VehicleReportPrintAvailability = _resolveComponent("VehicleReportPrintAvailability")!
  const _component_VehicleReportPrintCanceledTable = _resolveComponent("VehicleReportPrintCanceledTable")!
  const _component_VehicleReportPrintRestriction = _resolveComponent("VehicleReportPrintRestriction")!
  const _component_q_page = _resolveComponent("q-page")!

  return (!_ctx.loading)
    ? (_openBlock(), _createBlock(_component_q_page, {
        key: 0,
        class: "q-my-md"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _hoisted_2,
              _createElementVNode("div", _hoisted_3, "Period: " + _toDisplayString(_ctx.dateNow), 1)
            ]),
            _createVNode(_component_AppLogo)
          ]),
          _createVNode(_component_VehicleReportPrintAvailability, {
            "total-available-x10p": _ctx.totalAvailableX10p,
            "total-available-x15p": _ctx.totalAvailableX15p,
            "fordon-engligt-utsattningsplan": _ctx.fordonEnligtUtsattningsplan,
            "vehicle-type": "X10p"
          }, null, 8, ["total-available-x10p", "total-available-x15p", "fordon-engligt-utsattningsplan"]),
          _createVNode(_component_VehicleReportPrintCanceledTable, { list: _ctx.list }, null, 8, ["list"]),
          _createVNode(_component_VehicleReportPrintRestriction, { rows: _ctx.vehicleRestrictions }, null, 8, ["rows"])
        ]),
        _: 1
      }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _hoisted_4
      ], 64))
}